// Admin reporting and inputs always use India time, independent of the device.
export const ADMIN_TIME_ZONE = "Asia/Kolkata";
export const IST_OFFSET_MS = 19800000;
export const DAY_MS = 86400000;
export function asDate(value) {
  if (value === null || value === undefined || value === "") return null;
  if (value instanceof Date)
    return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value === "number" || /^\d+$/.test(value)) {
    const number = Number(value);
    value = number < 1e11 ? number * 1000 : number;
  } else if (
    typeof value === "string" &&
    /^\d{4}-\d\d-\d\d[ T]\d\d:\d\d/.test(value) &&
    !/(Z|[+-]\d\d:?\d\d)$/i.test(value)
  ) {
    value = value.replace(" ", "T") + "Z"; // Zone-less API timestamps are UTC.
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}
export function formatISTDateTime(value, options = {}) {
  const date = asDate(value);
  return date
    ? new Intl.DateTimeFormat("en-IN", {
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
        ...options,
        timeZone: ADMIN_TIME_ZONE,
        timeZoneName: "short",
      }).format(date)
    : "—";
}
export function formatISTDate(value, options = {}) {
  const date = asDate(value);
  return date
    ? new Intl.DateTimeFormat("en-IN", {
        day: "numeric",
        month: "short",
        year: "numeric",
        ...options,
        timeZone: ADMIN_TIME_ZONE,
      }).format(date)
    : "—";
}
export function istDateKey(value = Date.now()) {
  const date = asDate(value);
  return date
    ? new Date(date.getTime() + IST_OFFSET_MS).toISOString().slice(0, 10)
    : "";
}
export function istRangeStart(days = 30, now = Date.now()) {
  return istDateKey(now - (days - 1) * DAY_MS);
}
export function istISOString(value) {
  const date = asDate(value);
  return date
    ? new Date(date.getTime() + IST_OFFSET_MS)
        .toISOString()
        .replace("Z", "+05:30")
    : "";
}
export const toISTInput = (value) => istISOString(value).slice(0, 16);
export function fromISTInput(value) {
  if (!/^\d{4}-\d\d-\d\dT\d\d:\d\d$/.test(value || "")) return null;
  const date = asDate(`${value}:00+05:30`);
  return date && toISTInput(date) === value ? date : null;
}
export function formatCalendarDate(dateKey) {
  return formatISTDate(`${dateKey}T00:00:00+05:30`, {
    month: "short",
    day: "numeric",
    year: undefined,
  });
}
